module.exports = __webpack_public_path__ + "img/vue2-lacet_lavande.ddb331c7.png";